<template>
  <div class="faucet">
    <h2>请输入您的“以太坊实战环境”钱包地址，系统会向您转账1ETH测试币，用于进行实战任务。</h2>
    <Form ref="formData" :model="formData" :rules="rules" :label-width="70">
      <FormItem prop="address" label="地址：">
        <Input type="text" style="width: 300px" v-model.trim="formData.address" placeholder="请输入地址" />
        <Button class="btn" type="primary" @click="handleSubmit('formData')" :loading="loading">申请测试币</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { Form, FormItem, Input, Button, Message } from 'view-design'
import { ethAddr } from '@/utils/check'
export default {
  components: {
    Form,
    FormItem,
    Input,
    Button
  },
  data() {
    const validateEthAddr = (rule, value, callback) => {
      if (!ethAddr(value)) {
        callback(new Error('请输入正确的地址'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        address: '',
        amount: 1
      },
      loading: false,
      rules: {
        address: [
          {
            required: true,
            message: '请输入地址',
            trigger: 'blur'
          },
          {
            validator: validateEthAddr,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.transfer()
        }
      })
    },
    // 转账
    async transfer() {
      const params = {
        uriCode: 'API016',
        ...this.formData
      }
      this.loading = true
      try {
        await this.$fetch(params)
        Message.success('转账成功！')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.faucet {
  width: 550px;
  height: 200px;
  margin: 200px auto 0;
  .btn {
    width: 120px !important;
    float: right;
    height: 32px !important;
  }
  h2 {
    letter-spacing: 1px;
    margin-bottom: 20px;
    line-height: 30px;
  }
}
</style>
